<template>
<div class="webdatalist">

    <f7-list media-list class="searchbar-found" id="group-list">
      <f7-list-group v-for="(group, key) in contactGroups" :key="key">
        <f7-list-item :title="key" group-title></f7-list-item>

        <div class="showLargeScreenOnly">
          <li
          v-for="contactGroup in group"
          :key="contactGroup.id"
          class="boxRequest"
          v-bind:media="'<div class=\'manualChip\'>'+contactGroup.label[0]+'</div>'">
            <div class="item-content boxRequest">
              <div class="item-inner">
                <div class="item-title">{{ contactGroup.label }}</div>
              </div>
              <div class="item-media">
                <button class="button-swipe-out" @click="removeContactGroup(contactGroup)">
                  <i class="fa fa-times-circle button-delete" ></i>
                </button>
              </div>
            </div>
          </li>
        </div>

        <div class="showSmallScreenOnly">
          <f7-list-item
          swipeout
          v-for="contactGroup in group"
          :title="contactGroup.label"
          :key="contactGroup.id"
          class="boxRequest"
          v-bind:media="'<div class=\'manualChip\'>'+contactGroup.label[0]+'</div>'"
          @swipeout:deleted="removeContactGroup(contactGroup)"
          @click="editContactGroup(contactGroup)">
            <f7-swipeout-actions>
              <f7-swipeout-button href="/account/editContactGroup/" class="swipeout-create">Edit</f7-swipeout-button>
              <f7-swipeout-button
              :data-confirm="$i18n.t('contacts.group_deletion_confirm')"
              :data-confirm-title="$i18n.t('common.rm_as_question')"
              data-close-on-cancel="true"
              delete>{{ $t('common.rm_label') }}</f7-swipeout-button>
            </f7-swipeout-actions>
          </f7-list-item>
        </div>

      </f7-list-group>
    </f7-list>
</div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'ContactGroupList',
  props: ['contactGroups', 'filterBy'],
  computed: {
  },
  methods: {
    editContact (contact) {
      this.$engine.settings.set({currentContact: contact})
      var formData = {
        'username': contact.name,
        'identifier': contact.identifier,
        'iban': contact.iban,
        'label': contact.label
      }
      this.$f7.formFromData('#EditContactForm', formData)
      this.$f7.popup('.EditContact')
    },
    removeContact (contactId) {
      let that = this
      this.$engine.contacts
        .delete(contactId)
        .then(resp => {
          that.identifier = ''
          that.username = ''
          that.$bus.$emit('refresh-cache-groups')
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
    },
    // OpenFormsPageContactGroup () {
    //   loadPage(this, {url: '/account/addContactGroup/'})
    // },
    editContactGroup (contactGroup) {
      this.$engine.settings.set({currentContactGroup: contactGroup})
      loadPage(this, {url: '/account/contactGroupDetail/'})
    },
    removeContactGroup (contactGroup) {
      let that = this
      that.$engine.contacts
      .deleteContactGroup(contactGroup.id)
      .then(resp => {
        that.$f7.modal({
          title: that.$i18n.t('common.deleted_item',
              {itemname: that.$i18n.t('contacts.group_label')}),
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
          that.$bus.$emit('refresh-cache-groups')
          loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMContactGroupList.vue?6f6f6ef2